<template>
  <router-link class="no-underline" :to="permalink">
    <card class="card" has-outline>
      <template v-slot:title>{{email}}</template>
      <template v-slot:badge>{{processor}}</template>
      <template>
          {{ amountPaid }} on <date-string :timestamp="createdAt" />
      </template>
    </card>
  </router-link>
</template>

<script>
import Card from '@/components/Card.vue';
import DateString from '@/components/DateString.vue';
import capitalizeFirstLetter from '@/utilities/capitalizeFirstLetter';

export default {
  name: 'PaymentPreview',
  components: {
    Card,
    DateString,
  },
  props: {
    id: String,
    createdAt: Object,
    currency: String,
    season: String,
    email: String,
    amount: Number,
    processor: String,
  },
  computed: {
    amountPaid() {
      return `${this.currency} ${(this.amount / 100).toLocaleString()}`;
    },
    paymentMethod() {
      return this.processor ? capitalizeFirstLetter(this.processor) : 'Cash';
    },
    permalink() {
      return {
        name: 'EditPayment',
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
